import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import BannerHome from "./BannerWWD"
import Intro from "./Intro"
import Message from "@components/Message"
import Integrations from "./Integrations"
import ClientOrgs from "./ClientOrgs"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "@styles/custom-bootstrap.scss"
import "@styles/global.scss"

const Home = props => {
  return (
    <div>
      <EngineIDNavBar />
      <BannerHome />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <Intro />
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default Home
